module.exports = __webpack_public_path__ + "16d4613dbda9214f66e725058d144241.svg";